import { BasePage } from "../BasePage";
import ProfilePage from "./ProfilePage";
import { observer } from "mobx-react";
import { useIsMobileWeb } from "@/hooks/useIsMobileWeb";
import DownloadAppCta from "@/components/mobile/DownloadAppCta";

const Profile = observer(() => {
  const isMobileWeb = useIsMobileWeb();

  if (isMobileWeb) {
    return (
      <main className="min-h-screen w-full bg-[#F7F8F7]">
        <ProfilePage />
        <DownloadAppCta />
      </main>
    );
  }

  return (
    <BasePage activeItem="profile" contentClassName="md:pt-0">
      <ProfilePage />
    </BasePage>
  );
});

export default Profile;
